import { PurchaseOrderDeliveryGetMinDto } from '../PurchaseOrderDeliveryGetMinDto';
import { PurchaseOrderGetMinDto } from '../PurchaseOrderGetMinDto';

export const purchaseOrderGetMinToEmptyFormik = (): PurchaseOrderDeliveryGetMinDto => {
  const formik: PurchaseOrderDeliveryGetMinDto = {
    id: '',
    driverFirstName: '',
    driverLastName: '',
    eta: null,
    truckPlate: '',
    orderId: '',
    orderNumber: 0,
    timeSlot: null,
    logisticsCompany: '',
    contacts: '',
    cmrNumber: '',
    cmrDate: null,
    loadingReference: '',
    warehouseOwnerId: '',
    dateAvailable: null,
  };

  return formik;
}